import { render, staticRenderFns } from "./VideoContainer.vue?vue&type=template&id=1a727c68&"
import script from "./VideoContainer.vue?vue&type=script&lang=js&"
export * from "./VideoContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/36115602/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a727c68')) {
      api.createRecord('1a727c68', component.options)
    } else {
      api.reload('1a727c68', component.options)
    }
    module.hot.accept("./VideoContainer.vue?vue&type=template&id=1a727c68&", function () {
      api.rerender('1a727c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/VideoContainer.vue"
export default component.exports